const spliteFlagWraper = 'page-splite-flag-wraper';
const spliteFlag = 'page-splite-flag';
const pageHeight = 1500;
const tableClass = 'card-table';
const cardTableTopWraper = '.card-table-top-wraper';
const cardTableWraper = '.card-table-wraper';
const cardTableBomWraper = '.card-table-bom-wraper';
const cardTableTBHeaderWraper = '.el-table__header-wrapper';
const cardElRowClass = '.el-table__row';
const elTableBodyWraper = '.el-table__body-wrapper';
const elTbody = 'tbody';
const minRowsCount = 6;
const rowHeight = 40;
const headerHeight = 40;
const wrapePadTop = 20;

export {
	spliteFlagWraper,
	spliteFlag,
	pageHeight,
	tableClass,
	cardTableTopWraper,
	cardTableWraper,
	cardTableBomWraper,
	cardTableTBHeaderWraper,
	cardElRowClass,
	elTableBodyWraper,
	elTbody,
	minRowsCount,
	rowHeight,
	headerHeight,
	wrapePadTop
};
